import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';

import { notification } from '../utils/messaging';
import { format422ApiError } from '../utils/format422ApiError';

const FALLBACK_422_DESCRIPTION =
  'OOPS! There was an issue processing your request. If this persists please contact our support team';

export const defaultErrorNotification = (err) => {
  console.error(err?.response?.data);
  if (axios.isAxiosError(err)) {
    if (err?.response?.status === 500) {
      notification.error({
        description: 'Server Response failed. Please try again later',
      });
    } else if (
      err?.response?.status === 401 ||
      (err?.response?.status === 422 &&
        err?.response?.data.detail === 'Signature has expired')
    ) {
      notification.error({
        description: 'Please Login and try again!',
      });
    } else if (err?.response?.status === 422) {
      const formatted = format422ApiError(err?.response?.data?.detail);
      notification.error({
        description: formatted ?? FALLBACK_422_DESCRIPTION,
      });
    } else {
      notification.error({
        description: err?.response?.data.detail,
      });
    }
  } else if (err?.data?.detail) {
    notification.error({
      description: err?.data?.detail,
    });
  } else {
    notification.error({
      description: 'Something went wrong!',
    });
  }
};

export const axiosBaseQuery =
  ({ baseURL = '' }) =>
  async (
    { url, method, data, params, headers = {}, useDefaultErrorHandler = true },
    { dispatch }
  ) => {
    const {
      Accept = 'application/json',
      'Content-Type': ContentType = 'application/json',
      ...otherHeaders
    } = headers;
    try {
      const result = await axios({
        url: baseURL + url,
        method,
        data,
        params,
        headers: {
          Accept: Accept,
          'Content-Type': ContentType,
          ...otherHeaders,
        },
        withCredentials: true,
      });
      if (result.status === 200) {
        return { data: result.data?.result ?? result.data };
      } else {
        return {
          error: {
            status: data.status,
            data: data,
          },
        };
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (useDefaultErrorHandler) {
          defaultErrorNotification(err);
        }
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
      if (useDefaultErrorHandler) {
        defaultErrorNotification(err);
      }
      return {
        error: {
          status: 500,
          data: JSON.stringify(err),
        },
      };
    }
  };

export const proApiSlice = createApi({
  baseQuery: axiosBaseQuery({
    baseURL: `${process.env.REACT_APP_PRO_URL}`,
  }),
  reducerPath: 'proApi',
  tagTypes: [],
  endpoints: () => ({}),
});
